import React, { useEffect, useState } from 'react';

export const ProgressBar = ({ filled, max, containerClassName }: { filled: number; max: number; containerClassName?: string }) => {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    setTimeout(() => {
      setProgress(max ? (filled * 100) / max : 0);
    }, 0.1);
  }, [filled, max]);

  return (
    <div className={`flex items-center h-full w-full  ${containerClassName}`}>
      <div className={`bg-[#e9e9e9] rounded-lg w-full mt-4  flex items-center`}>
        <div style={{ width: `${progress >= 100 ? 100 : progress}%` }} className={`ease-in duration-75 bg-[#3e7aeb] h-2.5 rounded-2xl`} />
      </div>
    </div>
  );
};
